import {remove} from 'lodash';
import * as moment from 'moment/moment';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {PortfolioUtil} from '../utils/PortfolioUtil';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {MatPaginator} from '@angular/material/paginator';
import {ChartData} from '../doughnut/doughnut.component';
import {ChartDataUtil} from '../doughnut/chart-data.util';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {PortfolioType} from '../model/portfolio-type.model';
import {WriteOffService} from '../service/write-off.service';
import {PortfolioService} from '../service/portfolio.service';
import {Keys, StorageService} from '../service/storage.service';
import {PreferencesService} from '../service/preferences.service';
import {LenderDetailsService} from '../service/lender-details.service';
import {ManualinvestdetailComponent} from '../portfolio-creation/manualinvestdetail/manualinvestdetail.component';
import {HttpClient} from '@angular/common/http';
import {LoanUtil} from '../utils/loan.util';

@Component({
    selector: 'app-portfoliodetail',
    templateUrl: './portfolio-detail.component.html',
    styleUrls: ['./portfolio-detail.component.scss'],
    providers: [ApiServiceService, PreferencesService, WriteOffService]
})
export class PortfolioDetailComponent implements OnInit {
    result2: any;
    result: any;
    portfolioId: string;
    portfolio_name: string;
    portfolio_amt: number;
    loan_details: any;
    loan_details_array: any = [];
    portfolio_type: PortfolioType;
    portfolio_date: string;
    metrics: any;
    portfolio_amt_after_payment = 0;
    roi;
    displayedColumns: any = ['loan', 'status', 'rating', 'fund_allocation', 'borrower'];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
    data: Array<any>;
    chartData: ChartData[] = [];
    remainingAmount: number;

    shouldShowLoader: boolean;

    constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private ref: ApiServiceService,
                private storageService: StorageService, private portfolioService: PortfolioService, public dialog: MatDialog,
                private lenderDetailsService: LenderDetailsService, private writeOffService: WriteOffService,
                private readonly chartDataUtil: ChartDataUtil) {
    }

    @ViewChild(MatPaginator)
    public set paginator(value: MatPaginator) {
        this.dataSource.paginator = value;
    }

    @ViewChild(MatSort)
    public set sort(value: MatSort) {
        this.dataSource.sort = value;
    }

    goToLoan(id, status) {
        if (status !== 'closed') {
            this.router.navigate(['/loandetail/' + id]);
        }
    }

    viewLoanDetails(loan, investmentAmount) {
        const dialogRef = this.dialog.open(ManualinvestdetailComponent, {data: {...loan, investmentAmount}, panelClass: 'manual-invest-details-dialog'});
    }

    async ngOnInit() {
        this.shouldShowLoader = true;
        this.portfolioId = this.route.snapshot.params['id'];
        this.result2 = await this.http.post<any>(this.ref.baseURL() + 'getLenderPortfolioDetails',
            {
                portfolio_id: this.portfolioId,
                token: this.storageService.getItem(Keys.TOKEN),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID)
            }).toPromise();
        let response = this.result2;

        const portfolioType = response.portfolio_details[0].portfolio_type;
        if (this.isConsolidatedPortfolioType(portfolioType)) {
            const reinvestPortfoliosResponse: any = await this.http.post<any>(this.ref.baseURL() + 'getLenderPortfolio',
                {
                    lender_id: this.storageService.getItem(Keys.LENDER_ID),
                    token: this.storageService.getItem(Keys.TOKEN),
                    profile_id: this.storageService.getItem(Keys.PROFILE_ID)
                }).toPromise();
            remove(reinvestPortfoliosResponse.portfolio_details, (portfolio: any) => portfolio.portfolio_type !== portfolioType);
            PortfolioUtil.aggregatePortfoliosByType(reinvestPortfoliosResponse.portfolio_details, portfolioType);
            response = this.result2 = {
                status_code: reinvestPortfoliosResponse.status_code,
                portfolio_details: reinvestPortfoliosResponse.portfolio_details
            };
        }

        if (response.status_code == 201) {
            const portfolioDetails = response.portfolio_details[0];

            this.populateChartData(portfolioDetails);

            this.portfolio_name = portfolioDetails.portfolio_name;
            this.remainingAmount = portfolioDetails.remaining_amt;
            this.storageService.saveItem(Keys.PORTFOLIO_NAME, this.portfolio_name);
            this.storageService.saveItem(Keys.PORTFOLIO_ID, this.portfolioId);
            this.portfolio_amt = portfolioDetails.investment_amt;
            this.loan_details = portfolioDetails.loan_details.concat(portfolioDetails.closed_loan_details);
            this.portfolio_type = portfolioDetails.portfolio_type;
            this.portfolio_date = moment(portfolioDetails.createdAt).format('D MMM YYYY');

            for (let i = 0; i < this.loan_details.length; i++) {
                const loanDetail = this.loan_details[i];
                this.loan_details_array.push(this.createLoanDetailsViewModel(loanDetail,
                    LoanUtil.getDisplayableLoanStatus(loanDetail.loan_id.loan_sanction_status, !!loanDetail.loan_id.loanRestructuredOn, loanDetail.loan_id.filled_percentage)));
                if (loanDetail.loan_id.loan_sanction_status != 'closed_prepayment') {
                    this.portfolio_amt_after_payment = this.portfolio_amt_after_payment + loanDetail.fund_allocation;
                }

            }

            await this.getMetricsForPortfolio();
            this.roi = await this.getRoiForPortfolio(portfolioDetails);

            this.dataSource.data = this.loan_details_array;

            console.log(this.loan_details_array)

            const loanId = this.route.snapshot.queryParamMap.get('loanId');
            if (loanId) {
                const loanDetails = this.loan_details.find(loan => loan.loan_id._id.toString() === loanId);
                this.viewLoanDetails(loanDetails.loan_id, loanDetails.fund_allocation);
            }
        }
        this.shouldShowLoader = false;
    }

    async getMetricsForPortfolio(): Promise<void> {
        this.metrics = await this.portfolioService.getPortfolioMetrics(this.portfolioId);
    }

    public populateChartData(portfolio: any) {
        this.chartData = this.chartDataUtil.convertToChartDataForPortfolio(portfolio);
    }

    public async getRoiForPortfolio(portfolio: any): Promise<number> {
        if (this.isConsolidatedPortfolioType(portfolio.portfolio_type)) {
            const lenderId = this.storageService.getItem(Keys.LENDER_ID);
            const metrics = await this.lenderDetailsService.getMetricsForPortfolioType(lenderId, portfolio.portfolio_type);
            return metrics.roi;
        } else {
            return this.metrics.roi;
        }
    }

    public hasMadeInvestments(): boolean {
        return this.dataSource.filteredData.length > 0;
    }

    public isConsolidatedPortfolioType(portfolioType: PortfolioType): boolean {
        return portfolioType === PortfolioType.Reinvest || portfolioType === PortfolioType.FinzyBolt;
    }

    private createLoanDetailsViewModel(loanDetail, loanStatus: string) {
        return {
            status: loanStatus,
            _id: loanDetail.loan_id._id,
            loan_data: loanDetail.loan_id,
            rating: loanDetail.loan_id.rating,
            fund_allocation: loanDetail.fund_allocation,
            generated_loan_id: loanDetail.loan_id.generated_loan_id,
            loan_sanction_status: loanDetail.loan_id.loan_sanction_status,
        };
    }
}
